export * from "./animations";

export const theme = {
  screens: {
    mobile: 0,
    tablet: 768,
    desktop: 1024,
  },
  transitions: {
    default: "200ms ease-in-out",
  },
} as const;

export type Theme = typeof theme;
